import { FC } from 'react';

type Props = {
  width?: number;
  height?: number;
  className?: string;
  color?: string;
};

const FilledStar: FC<Props> = ({ width = 33, height = 32, className, color = "#E4C425" }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 30 30"
      width={width}
      height={height}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.152 2.46851L11.0523 10.7761L1.88867 12.1006L8.52034 18.5701L6.95253 27.6977L15.152 23.3907L23.3515 27.6977L21.7837 18.5701L28.4153 12.1097L19.2517 10.7761L15.152 2.46851Z"
        fill={color}
      />
    </svg>
  );
};

export default FilledStar;
